import React from 'react';
import { DateFilter, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import RepairOrderOpenListScreen from './List';
import FtsSearch from '../../Components/TableFilters/FtsSearch';

const { headings } = vars;
const textStyle = { ...headings.pageHeading, marginLeft: 12 };

export default {
  [ROUTES.fiSaleClosedList.name]: {
    screen: RepairOrderOpenListScreen,
    expanded: true,
    title: () => <Text style={textStyle}>Repair Orders</Text>,
    headerActions: [
      (props) => (
        <FtsSearch
          {...props}
          action={{
            exp: [
              'name',
              'repairOrderNumber',
              'year',
              'make',
              'model',
              'mileage',
              'vin',
              'email',
            ],
          }}
        />
      ),
      <DateFilter field="openDate" key="openDate" />,
    ],
  },
};
